/**
 * Formats a date to the start of the day (midnight) without mutating the original date.
 * Returns a new Date object with hours, minutes, seconds, and milliseconds set to 0.
 *
 * @param date - The date to format
 * @returns A new Date object set to midnight of the same day
 */
export function formatDateToStartOfDay(date: Date): Date {
  const result = new Date(date);
  result.setHours(0, 0, 0, 0);
  return result;
}
